<div class="without-taly-main">
    <div class="col-5">
        <taly-order-details />
        <taly-payment-method [type]="'withouttaly'"/>
    </div>
    <div class="col-5 img-bg">
        <img src="assets/images/without-taly.svg" alt="">
    </div>
</div>